import { Component } from '@verndale/core';

class FormsBlock extends Component {
  constructor(el) {
    super(el);
    this.tabs = [];
    this.firstTab = null;
    this.lastTab = null; 
    this.tabpanels = [];
    this.handleIsOnViewportBound = null;
    
    this.setupDefaults();
    this.addListeners();
    this.handleIsOnViewportBound = this.handleIsOnViewport.bind(this);
    this.addFormListeners();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      tabList: this.el.querySelectorAll('[role=tab]'),
      tabPanels: this.el.querySelectorAll('[role=tabpanel]'),
      closeBtnForms: this.el.querySelector('.close-btn-forms'),
      rightContainer: document.querySelector('.main-block__container-right'),
      formsBlockHeader: this.el.querySelector('.forms-block__header'),
      contactUsSitecoreForm: this.el.querySelector('.contact-us__sitecore-form'),
      priceEl: this.el.querySelector('.forms-block__title'),
      mobilePriceEl: document.querySelector('.form-block-btn__price'),
      navPriceEl: document.querySelector('.sticky-nav__price'),
      loanCalculatorSection: document.querySelector('.loan-calculator'),
    };
    this.tabs = Array.from(this.dom.tabList);
    this.firstTab = this.tabs[0];
    this.lastTab = this.tabs[this.tabs.length - 1];
    this.tabpanels = Array.from(this.dom.tabPanels);
    this.initializeTabs();
  }

  initializeTabs() {
    this.tabs.forEach((tab, index) => {
      if (index === 0) {
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      }
    });
    this.tabpanels.forEach(panel => {
      panel.setAttribute('aria-hidden', 'true');
    });
    // Optionally show the first tab content on load
    const firstPanel = this.el.querySelector(`#${this.firstTab.getAttribute('aria-controls')}`);
    if (firstPanel) {
      firstPanel.setAttribute('aria-hidden', 'false');
    }
  }

  addListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', e => this.handleSelectedTab(e));
      tab.addEventListener('keydown', e => this.handleArrowNavigation(e));
    });
    this.dom.closeBtnForms.addEventListener(
      'click',
      this.handleCloseForms.bind(this)
    );
    window.addEventListener('scroll', this.handleIsOnViewport.bind(this));
  }

  addFormListeners() {
    const formResponseObserver = new MutationObserver((mutationsList, observer) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const formResponseEl = document.querySelector('.contact-us__form .form__response');
          if (formResponseEl) {
            this.unlockPrice();
            observer.disconnect();
            break;
          }
        }
      }
    });

    formResponseObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  isLargeDesktop() {
    return window.matchMedia(`(min-width: 1024px`).matches;
  }

  unlockPrice() {
    const unlockedPrice = this.el.dataset.unlockedPrice;
    const contactButtonContainer = document.querySelector('.sticky-nav__right-container');

    if (unlockedPrice) {
      const hideElements = document.querySelectorAll('.hide-after-unlock');
      const showElements = document.querySelectorAll('.show-after-unlock');

      hideElements.forEach(el => {
        el.style.display = 'none';
      });

      showElements.forEach(el => {
        el.style.display = 'block';
      });

      if (this.dom.navPriceEl) {
        this.dom.navPriceEl.innerText = unlockedPrice;
      }

      if (contactButtonContainer) {
        const contactButton = contactButtonContainer.querySelector('.btn');
        if (contactButton) {
          contactButton.style.display = 'none';
        }
      }

      if (this.dom.loanCalculatorSection) {
        this.dom.loanCalculatorSection.style.display = 'block';
      }
    }
  }

  handleCloseForms() {
    this.dom.el.classList.remove('pop-up');
    this.dom.rightContainer.style.removeProperty('display');
    document.body.style.removeProperty('overflow');
  }

  handleSelectedTab(e) {
    const tab = e.target;
    const tabId = tab.getAttribute('aria-controls');
    const tabpanel = this.el.querySelector(`#${tabId}`);

    this.tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    this.tabpanels.forEach(panel => {
      panel.setAttribute('aria-hidden', 'true');
    });

    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tabpanel.setAttribute('aria-hidden', 'false');
    this.handleIsOnViewport();
  }

  handleArrowNavigation(e) {
    const key = e.which || e.keyCode;
    if (key === 37 || key === 39) {
      e.preventDefault();
      const currentIndex = this.tabs.indexOf(e.target);
      if (key === 37) {
        // left
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
        this.tabs[prevIndex].focus();
      } else if (key === 39) {
        // right
        const nextIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
        this.tabs[nextIndex].focus();
      }
    }
  }

  handleIsOnViewport() {
    const rect = this.el.getBoundingClientRect();
    const titleRect = this.dom.formsBlockHeader.getBoundingClientRect();

    if (titleRect.top <= 100) {
      return;
    }

    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight)) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      if (this.el.classList.contains('no-sticky')) {
        this.el.classList.remove('no-sticky');
      }
    } else {
      this.el.classList.add('no-sticky');
    }
  }
}

export default FormsBlock;
